import Avatar from '@pelckmans/elementis/components/avatar';
import { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import UserImagesContext from '../../../contexts/UserImagesContext';
import useClickOutside from '../../../hooks/useClickOutside';
import UserMenu from './UserMenu';

function User() {
  const [showMenu, setShowMenu] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [avatarEl, setAvatarEl] = useState<HTMLButtonElement | null>(null);

  const { avatar } = useContext(UserImagesContext);

  useClickOutside({
    ref: containerRef,
    elementId: 'user-menu',
    onClickOutside: () => setShowMenu(false),
    enabled: showMenu,
  });

  const { t } = useTranslation();

  const closeMenu = () => {
    setShowMenu(false);
    avatarEl?.focus();
  };

  const handleCollapse = (event?: Event) => {
    if (event?.type === 'mousedown' && avatarEl?.contains(event.target as Node)) return;

    closeMenu();
  };

  return (
    <div ref={containerRef}>
      <Avatar
        ref={el => setAvatarEl(el as HTMLButtonElement)}
        aria-haspopup="menu"
        aria-expanded={showMenu}
        aria-controls="user-menu"
        onClick={() => setShowMenu(x => !x)}
      >
        <Avatar.Image name={t('APP_NAV.SIDE_NAV.IMAGE.ALT')} src={avatar} size="lg" />
      </Avatar>
      {showMenu && <UserMenu referenceEl={containerRef.current} actionEl={avatarEl} onCollapse={handleCollapse} />}
    </div>
  );
}

export default User;
